import "./App.css";
import { Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import UnauthorizedPage from "./pages/UnauthorizedPage";
import useAuth from "./hooks/useAuth";
import ProtectedRoute from "./routes/ProtectedRoute";
import TitledRoutes from "./routes/TitledRoutes";
import IncidentsPage from "./pages/Fleet/IncidentsPage";
import AssetsPage from "./pages/Fleet/AssetsPage";
import TrailerPage from "./pages/Fleet/TrailerPage";
import TruckPage from "./pages/Fleet/TruckPage";
import NotFoundPage from "./pages/NotFoundPage";
import MoneyRequestsPage from "./pages/Fleet/MoneyRequestPage";
import DriverPage from "./pages/Fleet/DriverPage";
import DriverDetailsPage from "./pages/Fleet/DriverDetailsPage";
import EquipmentInventoryPage from "./pages/Fleet/EquipmentInventoryPage";
import YardRepairsPage from "./pages/Fleet/YardRepairsPage";
import FleetHomePage from "./pages/Fleet/FleetHomePage";
import HomePage from "./pages/HomePage";
import NavigationBar from "./components/General/NavigationBar/NavigationBar";
import HRHomePage from "./pages/HR/HRHomePage";
import EmployeesPage from "./pages/HR/EmployeesPage";
import TimeOffPage from "./pages/HR/TimeOffPage";
import TimeOffRequestsPage from "./pages/HR/TimeOffRequestsPage";
import TimeOffCalculationsPage from "./pages/HR/TimeOffCalculationsPage";
import CRMHomepage from "./pages/FleetCRM/CRMHomepage";
import CompanyPage from "./pages/Fleet/CompanyPage";
import AvailabilityPage from "./pages/HR/AvailabilityPage";
import ExternalLeadFormPage from "./pages/FleetCRM/ExternalLeadFormPage";
import EmployeeFoldersPage from "./pages/HR/EmployeeFoldersPage";
import EmployeeFinancialsPage from "./pages/HR/EmployeeFinancialsPage";
import ExchangeRatesPage from "./pages/HR/ExchangeRatesPage";
import EmployeeHistoryPage from "./pages/HR/EmployeeHistoryPage";
import WorkedTimeSummaryPage from "./pages/HR/WorkedTimeSummaryPage";
import PaymentsPage from "./pages/Fleet/PaymentsPage";
import CRMBoardPage from "./pages/FleetCRM/CRMBoardPage";
import CandidateBoardPage from "./pages/HireCRM/CandidateBoardPage";
import ExternalCandidateFormPage from "./pages/HireCRM/ExternalCandidateFormPage";
import ChargesPage from "./pages/Fleet/ChargesPage";
import RentsPage from "./pages/Fleet/RentsPage";
import LoansPage from "./pages/Fleet/LoansPage";
import SalesPage from "./pages/Fleet/SalesPage";
import LendersPage from "./pages/Fleet/LendersPage";
import RentPaymentPage from "./pages/Fleet/RentPaymentPage";
import SalesHomePage from "./pages/Sales/SalesHomePage";
import TruckSalesPage from "./pages/Sales/TruckSalesPage";
import TrailerSalesPage from "./pages/Sales/TrailerSalesPage";
import DispatchersPage from "./pages/Fleet/DispatchersPage";
import DeductionAuthorizationDraftForm from "./components/Fleet/DeductionAuthorizationForm/DeductionAuthorizationDraftForm";
import DeductionAuthorizationReviewPage from "./components/Fleet/DeductionAuthorizationForm/DeductionAuthorizationReviewPage";
import ThankYouPage from "./pages/ThankYouPage";
import UsersPage from "./pages/Auth/UsersPage";
import ApiKeysPage from "./pages/Auth/ApiKeysPage";
import Invoices from "./pages/Fleet/Invoices";
import Reports from "./pages/Reports";
import { CompanyUnits } from "./pages/Fleet/CompanyUnits";
import LogsPage from "./pages/LogsPage";
import RepairShopMap from "./components/Fleet/RepairShopMap/RepairShopMap";
import AccidentsPage from "./pages/Fleet/AccidentsPage";
import HarshEventsPage from "./pages/Fleet/HarshEventsPage";
import LogbookCheckPage from "./pages/Fleet/LogbookCheckPage";
import FleetLayout from "./components/Fleet/FleetLayout/FleetLayout";
import CRMLayout from "./components/FleetCRM/CRMLayout/CRMLayout";
import HRLayout from "./components/HR/HRLayout/HRLayout";
import LogsLayout from "./components/Logs/LogsLayout/LogsLayout";
import SalesLayout from "./components/Sales/SalesLayout/SalesLayout";
import AccountingLayout from "./components/Accounting/AccountingLayout/AccountingLayout";
import AccountingHomePage from "./pages/Accounting/AccountingHomePage";
import HourlyPaidDriversPage from "./pages/Accounting/HourlyPaidDriversPage";
import SafetyLayout from "./components/Safety/SafetyLayout/SafetyLayout";
import SafetyHomePage from "./pages/Safety/SafetyHomePage";
import HireLayout from "./components/HireCRM/HireLayout/HireLayout";
import ScheduledCandidatesPage from "./pages/HireCRM/ScheduledCandidatesPage";
import YardRecallSchedulePage from "./pages/Fleet/YardRecallSchedulePage";
import CameraCheckPage from "./pages/Fleet/CameraCheckPage";
import PreTripInspectionCheckPage from "./pages/Safety/PreTripInspectionCheckPage";
import OperationsLayout from "./components/Operations/OperationsLayout/OperationsLayout";
import OperationsPlannerPage from "./pages/Operations/OperationsPlannerPage";
import BrokerBlacklistPage from "./pages/Operations/BrokerBlacklistPage";
import DispatchersPasswordsPage from "./pages/Operations/DispatchersPasswordsPage";
import OperationsSeatedReportPage from "./pages/Operations/OperationsSeatedReportPage";
import OperationsUtilizationReportPage from "./pages/Operations/OperationsUtilizationReportPage";
import OperationsGrossReportPage from "./pages/Operations/OperationsGrossReportPage";
import OperationsAvailableTrucksPage from "./pages/Operations/OperationsAvailableTrucksPage";
import OperationsFindMyTruckPage from "./pages/Operations/OperationsFindMyTruckPage";
import OperationsDriversPage from "./pages/Operations/OperationsDriversPage";
import OperationsDriverPerformancePage from "./pages/Operations/OperationsDriverPerformancePage";
import PreTripInspectionMissedStreaksPage from "./pages/Safety/PreTripInspectionMissedStreaksPage";
import RecruitingLayout from "./components/Recruiting/RecruitingLayout/RecruitingLayout";
import RecruitingHomePage from "./pages/Recruiting/RecruitingHomePage";
import OrientationSchedulePage from "./pages/Recruiting/OrientationSchedulePage";
import OrientationExpensesPage from "./pages/Recruiting/OrientationExpensesPage";
import OrientationCalendarPage from "./pages/Recruiting/OrientationCalendarPage";
import DriverIssuesPage from "./pages/Recruiting/DriverIssuesPage";
import ApplicantsPage from "./pages/Recruiting/ApplicantsPage";
import CompliancePage from "./pages/Fleet/CompliancePage";
import RentalLayout from "./components/Rental/RentalLayout/RentalLayout";
import RentalHomePage from "./pages/Rental/RentalHomePage";
import ProfitabilityForecastPage from "./pages/Rental/ProfitabilityForecastPage";
import ExternalEventsPage from "./pages/HR/ExternalEventsPage";
import ResignationLettersPage from "./pages/HR/ResignationLettersPage";
import OpenPositionsPage from "./pages/HR/OpenPositionsPage";
import PermitsLayout from "./components/Permits/PermitsLayout/PermitsLayout";
import PermitsHomePage from "./pages/Permits/PermitsHomePage";
import PublicPermitRouteMapPage from "./pages/Permits/PublicPermitRouteMapPage";
import TicketsLayout from "./components/Tickets/TicketsLayout/TicketsLayout";
import DepartmentTicketsPage from "./pages/Tickets/DepartmentTicketsPage";
import DepartmentTicketDetailsPage from "./pages/Tickets/DepartmentTicketDetailsPage";
import PtoAccrualSubPoliciesPage from "./pages/HR/PtoAccrualSubPoliciesPage";
import PublicAssetDocumentsPage from "./pages/Fleet/PublicAssetDocumentsPage";

const App = () => {
  const { isLoading, isInitialized } = useAuth();

  if (!isInitialized || isLoading) {
    return <></>;
  }

  const operationsPlannerElement = (
    <ProtectedRoute requiredRole="Operations">
      <OperationsLayout>
        <OperationsPlannerPage />
      </OperationsLayout>
    </ProtectedRoute>
  );

  const operationsSeatedReportElement = (
    <ProtectedRoute requiredRole="OperationsManager">
      <OperationsLayout>
        <OperationsSeatedReportPage />
      </OperationsLayout>
    </ProtectedRoute>
  );

  const operationsUtilizationReportElement = (
    <ProtectedRoute requiredRole="OperationsManager">
      <OperationsLayout>
        <OperationsUtilizationReportPage />
      </OperationsLayout>
    </ProtectedRoute>
  );

  const operationsGrossReportElement = (
    <ProtectedRoute requiredRole="OperationsAdmin">
      <OperationsLayout>
        <OperationsGrossReportPage />
      </OperationsLayout>
    </ProtectedRoute>
  );

  const operationsAvailableTrucksElement = (
    <ProtectedRoute requiredRole="Operations">
      <OperationsLayout>
        <OperationsAvailableTrucksPage />
      </OperationsLayout>
    </ProtectedRoute>
  );

  const operationsFindMyTruckElement = (
    <ProtectedRoute requiredRole="Operations">
      <OperationsLayout>
        <OperationsFindMyTruckPage />
      </OperationsLayout>
    </ProtectedRoute>
  );

  const permitsElement = (
    <ProtectedRoute requiredRole="Permits">
      <PermitsLayout>
        <PermitsHomePage />
      </PermitsLayout>
    </ProtectedRoute>
  );

  const operationsDriversElement = (
    <ProtectedRoute requiredRole="Operations">
      <OperationsLayout>
        <OperationsDriversPage />
      </OperationsLayout>
    </ProtectedRoute>
  );

  const operationsDriverPerformanceElement = (
    <ProtectedRoute requiredRole="OperationsManager">
      <OperationsLayout>
        <OperationsDriverPerformancePage />
      </OperationsLayout>
    </ProtectedRoute>
  );

  return (
    <TitledRoutes>
      <Route
        path="/login"
        handle={{ title: "Login" }}
        element={<LoginPage />}
      />
      <Route
        path="/unauthorized"
        handle={{ title: "Access Denied" }}
        element={<UnauthorizedPage />}
      />
      <Route
        path="/lead"
        handle={{ title: "External Lead" }}
        element={<ExternalLeadFormPage />}
      />
      <Route
        path="/candidate"
        handle={{ title: "Candidate Application" }}
        element={<ExternalCandidateFormPage />}
      />
      <Route
        path="/permit-route-map"
        handle={{ title: "Permit Route Map" }}
        element={<PublicPermitRouteMapPage />}
      />
      <Route
        path="/deduction-form/new"
        handle={{ title: "New Deduction Authorization" }}
        element={<DeductionAuthorizationDraftForm />}
      />
      <Route
        path="/review/deduction-form/:token"
        handle={{ title: "Review Deduction Authorization" }}
        element={<DeductionAuthorizationReviewPage />}
      />
      <Route
        path="/thank-you"
        handle={{ title: "Thank You" }}
        element={<ThankYouPage />}
      />
      <Route
        path="/unit-documents/:assetType/:folderId"
        handle={{ title: "Unit Documents" }}
        element={<PublicAssetDocumentsPage />}
      />
      <Route
        path="/unit-documents/*"
        handle={{ title: "Unit Documents" }}
        element={<PublicAssetDocumentsPage />}
      />
      <Route
        path="*"
        handle={{ title: "Page Not Found" }}
        element={
          <ProtectedRoute requiredRole="User">
            <NotFoundPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/"
        handle={{ title: "Home" }}
        element={
          <ProtectedRoute requiredRole="User">
            <NavigationBar>
              <HomePage />
            </NavigationBar>
          </ProtectedRoute>
        }
      />

      <Route
        path="/tickets"
        handle={{ title: "Tickets" }}
        element={
          <ProtectedRoute requiredRole="User">
            <TicketsLayout>
              <DepartmentTicketsPage />
            </TicketsLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tickets/new"
        handle={{ title: "New Ticket" }}
        element={
          <ProtectedRoute requiredRole="User">
            <TicketsLayout>
              <DepartmentTicketsPage createMode />
            </TicketsLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/tickets/:id"
        handle={{ title: "Ticket Details" }}
        element={
          <ProtectedRoute requiredRole="User">
            <TicketsLayout>
              <DepartmentTicketDetailsPage />
            </TicketsLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/accounting"
        handle={{ title: "Accounting" }}
        element={
          <ProtectedRoute requiredRole="Accounting">
            <AccountingLayout>
              <AccountingHomePage />
            </AccountingLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/recruiting"
        handle={{ title: "Recruiting" }}
        element={
          <ProtectedRoute requiredRoles={["Recruiting", "Orientation"]}>
            <RecruitingLayout>
              <RecruitingHomePage />
            </RecruitingLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/recruiting/orientations"
        handle={{ title: "Orientation Schedule | Recruiting" }}
        element={
          <ProtectedRoute requiredRole="Recruiting">
            <RecruitingLayout>
              <OrientationSchedulePage />
            </RecruitingLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/recruiting/orientation-expenses"
        handle={{ title: "Orientation Expenses | Recruiting" }}
        element={
          <ProtectedRoute requiredRole="Recruiting">
            <RecruitingLayout>
              <OrientationExpensesPage />
            </RecruitingLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/recruiting/orientation-calendar"
        handle={{ title: "Orientation Calendar | Recruiting" }}
        element={
          <ProtectedRoute requiredRoles={["Recruiting", "Orientation"]}>
            <RecruitingLayout>
              <OrientationCalendarPage />
            </RecruitingLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/recruiting/driver-issues"
        handle={{ title: "Driver Issues | Recruiting" }}
        element={
          <ProtectedRoute requiredRole="Recruiting">
            <RecruitingLayout>
              <DriverIssuesPage />
            </RecruitingLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/recruiting/applicants"
        handle={{ title: "Applicants | Recruiting" }}
        element={
          <ProtectedRoute requiredRole="Recruiting">
            <RecruitingLayout>
              <ApplicantsPage />
            </RecruitingLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fleet"
        handle={{ title: "Fleet" }}
        element={
          <ProtectedRoute requiredRole="User">
            <FleetLayout>
              <FleetHomePage />
            </FleetLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fleet/incidents"
        handle={{ title: "Incidents | Fleet" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <FleetLayout>
              <IncidentsPage />
            </FleetLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fleet/yardRepairs"
        handle={{ title: "Yard Repairs | Fleet" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <FleetLayout>
              <YardRepairsPage />
            </FleetLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fleet/assets"
        handle={{ title: "Assets | Fleet" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <FleetLayout>
              <AssetsPage />
            </FleetLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fleet/assets/trailer/:id"
        handle={{ title: "Trailer Details | Fleet" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <FleetLayout>
              <TrailerPage />
            </FleetLayout>
          </ProtectedRoute>
        }
      >
        <Route
          path="maintenance/:operationId"
          handle={{ title: "Trailer Maintenance | Fleet" }}
          element={<TrailerPage />}
        />
      </Route>
      <Route
        path="/fleet/assets/truck/:id"
        handle={{ title: "Truck Details | Fleet" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <FleetLayout>
              <TruckPage />
            </FleetLayout>
          </ProtectedRoute>
        }
      >
        <Route
          path="maintenance/:operationId"
          handle={{ title: "Truck Maintenance | Fleet" }}
          element={<TruckPage />}
        />
      </Route>
      <Route
        path="/fleet/yardRecallSchedules"
        handle={{ title: "Yard Recall Schedule | Fleet" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <FleetLayout>
              <YardRecallSchedulePage />
            </FleetLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fleet/compliance"
        handle={{ title: "Compliance | Fleet" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <FleetLayout>
              <CompliancePage />
            </FleetLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/accounting/moneyRequests"
        handle={{ title: "Money Requests | Accounting" }}
        element={
          <ProtectedRoute requiredRole="User">
            <AccountingLayout>
              <MoneyRequestsPage />
            </AccountingLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fleet/drivers"
        handle={{ title: "Drivers | Fleet" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <FleetLayout>
              <DriverPage />
            </FleetLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fleet/drivers/:id"
        handle={{ title: "Driver Details | Fleet" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <FleetLayout>
              <DriverDetailsPage />
            </FleetLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fleet/equipment-inventory"
        handle={{ title: "Equipment Inventory | Fleet" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <FleetLayout>
              <EquipmentInventoryPage />
            </FleetLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/company/:companyId/assets"
        handle={{ title: "Company Units | Rental" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <RentalLayout>
              <CompanyUnits />
            </RentalLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/hr"
        handle={{ title: "My Profile | HR" }}
        element={
          <ProtectedRoute requiredRole="Employee">
            <HRLayout>
              <HRHomePage />
            </HRLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/hr/employees"
        handle={{ title: "Employees | HR" }}
        element={
          <ProtectedRoute requiredRole="HR">
            <HRLayout>
              <EmployeesPage />
            </HRLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/hr/promotions"
        handle={{ title: "Promotions | HR" }}
        element={
          <ProtectedRoute requiredRole="HR">
            <HRLayout>
              <EmployeeHistoryPage />
            </HRLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/hr/employee/:id"
        handle={{ title: "Employee Profile | HR" }}
        element={
          <ProtectedRoute requiredRole="HR">
            <HRLayout>
              <HRHomePage />
            </HRLayout>
          </ProtectedRoute>
        }
      />

      <Route
        path="/hr/timeoff/:id"
        handle={{ title: "Time Off | HR" }}
        element={
          <ProtectedRoute requiredRole="Employee">
            <HRLayout>
              <TimeOffPage />
            </HRLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/hr/time-off-requests"
        handle={{ title: "Time Off Requests | HR" }}
        element={
          <ProtectedRoute requiredRole="HR">
            <HRLayout>
              <TimeOffRequestsPage />
            </HRLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/hr/time-off-calculations"
        handle={{ title: "Time Off Calculations | HR" }}
        element={
          <ProtectedRoute requiredRole="HR">
            <HRLayout>
              <TimeOffCalculationsPage />
            </HRLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/hr/pto-accrual-policies"
        handle={{ title: "PTO Accrual Policies | HR" }}
        element={
          <ProtectedRoute requiredRole="HR">
            <HRLayout>
              <PtoAccrualSubPoliciesPage />
            </HRLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/hr/availability"
        handle={{ title: "Availability | HR" }}
        element={
          <ProtectedRoute requiredRole="Employee">
            <HRLayout>
              <AvailabilityPage />
            </HRLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/hr/external-events"
        handle={{ title: "External Events | HR" }}
        element={
          <ProtectedRoute requiredRole="Employee">
            <HRLayout>
              <ExternalEventsPage />
            </HRLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/hr/open-positions"
        handle={{ title: "Open Positions | HR" }}
        element={
          <ProtectedRoute requiredRoles={["Employee", "HR"]}>
            <HRLayout>
              <OpenPositionsPage />
            </HRLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/hr/resignation-letters"
        handle={{ title: "Resignation Letters | HR" }}
        element={
          <ProtectedRoute requiredRole="HR">
            <HRLayout>
              <ResignationLettersPage />
            </HRLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/hr/worked-time-summary"
        handle={{ title: "Worked Time Summary | HR" }}
        element={
          <ProtectedRoute requiredRole="HR">
            <HRLayout>
              <WorkedTimeSummaryPage />
            </HRLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/hr/employee-financials"
        handle={{ title: "Employee Financials | HR" }}
        element={
          <ProtectedRoute requiredRole="EmployeeFinancials">
            <HRLayout>
              <EmployeeFinancialsPage />
            </HRLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/hr/exchange-rates"
        handle={{ title: "Exchange Rates | HR" }}
        element={
          <ProtectedRoute requiredRole="EmployeeFinancials">
            <HRLayout>
              <ExchangeRatesPage />
            </HRLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="hr/documents"
        handle={{ title: "Documents | HR" }}
        element={
          <ProtectedRoute requiredRole="HeadOfHR">
            <HRLayout>
              <EmployeeFoldersPage />
            </HRLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fleet-crm"
        handle={{ title: "Dashboard | Fleet CRM" }}
        element={
          <ProtectedRoute requiredRole="FleetCRM">
            <CRMLayout>
              <CRMHomepage />
            </CRMLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fleet-crm/board"
        handle={{ title: "CRM Board | Fleet CRM" }}
        element={
          <ProtectedRoute requiredRole="FleetCRM">
            <CRMLayout>
              <CRMBoardPage />
            </CRMLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/hire-crm"
        handle={{ title: "Candidates | Hire CRM" }}
        element={
          <ProtectedRoute requiredRole="HireCRM">
            <HireLayout>
              <CandidateBoardPage />
            </HireLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/hire-crm/scheduled"
        handle={{ title: "Scheduled Candidates | Hire CRM" }}
        element={
          <ProtectedRoute requiredRole="HireCRM">
            <HireLayout>
              <ScheduledCandidatesPage />
            </HireLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/accounting/payments"
        handle={{ title: "Payments | Accounting" }}
        element={
          <ProtectedRoute requiredRole="Accounting">
            <AccountingLayout>
              <PaymentsPage />
            </AccountingLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/accounting/charges"
        handle={{ title: "Charges | Accounting" }}
        element={
          <ProtectedRoute requiredRole="Accounting">
            <AccountingLayout>
              <ChargesPage />
            </AccountingLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/accounting/rents"
        handle={{ title: "Rents | Accounting" }}
        element={
          <ProtectedRoute requiredRole="Accounting">
            <AccountingLayout>
              <RentsPage />
            </AccountingLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/accounting/rentPayments"
        handle={{ title: "Rent Payments | Accounting" }}
        element={
          <ProtectedRoute requiredRole="Accounting">
            <AccountingLayout>
              <RentPaymentPage />
            </AccountingLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/accounting/loans"
        handle={{ title: "Loans | Accounting" }}
        element={
          <ProtectedRoute requiredRole="Accounting">
            <AccountingLayout>
              <LoansPage />
            </AccountingLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/accounting/sales"
        handle={{ title: "Sales | Accounting" }}
        element={
          <ProtectedRoute requiredRole="Accounting">
            <AccountingLayout>
              <SalesPage />
            </AccountingLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/accounting/lenders"
        handle={{ title: "Lenders | Accounting" }}
        element={
          <ProtectedRoute requiredRole="Accounting">
            <AccountingLayout>
              <LendersPage />
            </AccountingLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fleet/dispatchers"
        handle={{ title: "Dispatchers | Fleet" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <FleetLayout>
              <DispatchersPage />
            </FleetLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fleet/users"
        handle={{ title: "Users | Fleet" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <FleetLayout>
              <UsersPage />
            </FleetLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sales"
        handle={{ title: "Sales" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <SalesLayout>
              <SalesHomePage />
            </SalesLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sales/trucks"
        handle={{ title: "Trucks | Sales" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <SalesLayout>
              <TruckSalesPage />
            </SalesLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/sales/trailers"
        handle={{ title: "Trailers | Sales" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <SalesLayout>
              <TrailerSalesPage />
            </SalesLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/rental/invoices"
        handle={{ title: "Invoices | Rental" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <RentalLayout>
              <Invoices />
            </RentalLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/fleet/reports"
        handle={{ title: "Reports | Fleet" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <FleetLayout>
              <Reports mode="fleetRental" />
            </FleetLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/accounting/hourly-paid-drivers"
        handle={{ title: "Hourly Paid Drivers | Accounting" }}
        element={
          <ProtectedRoute requiredRole="Accounting">
            <AccountingLayout>
              <HourlyPaidDriversPage />
            </AccountingLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/accounting/reports"
        handle={{ title: "Reports | Accounting" }}
        element={
          <ProtectedRoute requiredRole="Accounting">
            <AccountingLayout>
              <Reports mode="accounting" />
            </AccountingLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/rental/reports"
        handle={{ title: "Reports | Rental" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <RentalLayout>
              <Reports mode="fleetRental" />
            </RentalLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/rental"
        handle={{ title: "Rental" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <RentalLayout>
              <RentalHomePage />
            </RentalLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/rental/profitability-forecast"
        handle={{ title: "Profitability Forecast | Rental" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <RentalLayout>
              <ProfitabilityForecastPage />
            </RentalLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/rental/companies"
        handle={{ title: "Companies | Rental" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <RentalLayout>
              <CompanyPage />
            </RentalLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/rental/customers"
        handle={{ title: "Customers | Rental" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <RentalLayout>
              <UsersPage />
            </RentalLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/rental/compliance"
        handle={{ title: "Compliance | Rental" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <RentalLayout>
              <CompliancePage />
            </RentalLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/rental/rents"
        handle={{ title: "Rents | Rental" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <RentalLayout>
              <RentsPage />
            </RentalLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/rental/rentPayments"
        handle={{ title: "Rent Payments | Rental" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <RentalLayout>
              <RentPaymentPage />
            </RentalLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/logs"
        handle={{ title: "Logs" }}
        element={
          <ProtectedRoute requiredRole="Admin">
            <LogsLayout>
              <LogsPage />
            </LogsLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/api-integrations"
        handle={{ title: "API integrations" }}
        element={
          <ProtectedRoute requiredRole="Admin">
            <NavigationBar>
              <ApiKeysPage />
            </NavigationBar>
          </ProtectedRoute>
        }
      />
      <Route
        path="/permits"
        handle={{ title: "Permit Route | Permits" }}
        element={permitsElement}
      />
      <Route
        path="/permits/permit-route"
        handle={{ title: "Permit Route | Permits" }}
        element={permitsElement}
      />
      <Route
        path="/operations"
        handle={{ title: "Planner | Operations" }}
        element={operationsPlannerElement}
      />
      <Route
        path="/operations/planner"
        handle={{ title: "Planner | Operations" }}
        element={operationsPlannerElement}
      />
      <Route
        path="/operations/dispatchers-passwords"
        handle={{ title: "Dispatchers Passwords | Operations" }}
        element={
          <ProtectedRoute
            requiredRoles={[
              "Operations",
              "OperationsManager",
              "OperationsAdmin",
            ]}
          >
            <OperationsLayout>
              <DispatchersPasswordsPage />
            </OperationsLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/operations/broker-blacklist"
        handle={{ title: "Broker Blacklist | Operations" }}
        element={
          <ProtectedRoute
            requiredRoles={[
              "Operations",
              "OperationsManager",
              "OperationsAdmin",
            ]}
          >
            <OperationsLayout>
              <BrokerBlacklistPage />
            </OperationsLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/operations/drivers"
        handle={{ title: "Drivers | Operations" }}
        element={operationsDriversElement}
      />
      <Route
        path="/operations/driver-performance"
        handle={{ title: "Driver Performance | Operations" }}
        element={operationsDriverPerformanceElement}
      />
      <Route
        path="/operations/available-trucks"
        handle={{ title: "Available Trucks | Operations" }}
        element={operationsAvailableTrucksElement}
      />
      <Route
        path="/operations/seated-report"
        handle={{ title: "Seated Report | Operations" }}
        element={operationsSeatedReportElement}
      />
      <Route
        path="/operations/utilization-report"
        handle={{ title: "Utilization Report | Operations" }}
        element={operationsUtilizationReportElement}
      />
      <Route
        path="/operations/gross-report"
        handle={{ title: "Gross Report | Operations" }}
        element={operationsGrossReportElement}
      />
      <Route
        path="/operations/find-my-truck"
        handle={{ title: "Find My Truck | Operations" }}
        element={operationsFindMyTruckElement}
      />
      <Route
        path="/fleet/repairShops"
        handle={{ title: "Repair Shops | Fleet" }}
        element={
          <ProtectedRoute requiredRole="Fleet">
            <FleetLayout>
              <RepairShopMap />
            </FleetLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/safety"
        handle={{ title: "Safety" }}
        element={
          <ProtectedRoute requiredRole="Safety">
            <SafetyLayout>
              <SafetyHomePage />
            </SafetyLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/safety/accidents"
        handle={{ title: "Accidents | Safety" }}
        element={
          <ProtectedRoute requiredRole="Safety">
            <SafetyLayout>
              <AccidentsPage />
            </SafetyLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/safety/harshEvents"
        handle={{ title: "Harsh Events | Safety" }}
        element={
          <ProtectedRoute requiredRole="Safety">
            <SafetyLayout>
              <HarshEventsPage />
            </SafetyLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/safety/logbookChecks"
        handle={{ title: "Logbook Checks | Safety" }}
        element={
          <ProtectedRoute requiredRole="Safety">
            <SafetyLayout>
              <LogbookCheckPage />
            </SafetyLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/safety/cameraChecks"
        handle={{ title: "Camera Checks | Safety" }}
        element={
          <ProtectedRoute requiredRole="Safety">
            <SafetyLayout>
              <CameraCheckPage />
            </SafetyLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/safety/preTripInspectionChecks"
        handle={{ title: "Pre-Trip Inspection Checks | Safety" }}
        element={
          <ProtectedRoute requiredRole="Safety">
            <SafetyLayout>
              <PreTripInspectionCheckPage />
            </SafetyLayout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/safety/preTripInspectionChecks/missed"
        handle={{ title: "Missed Pre-Trip Inspections | Safety" }}
        element={
          <ProtectedRoute requiredRole="Safety">
            <SafetyLayout>
              <PreTripInspectionMissedStreaksPage />
            </SafetyLayout>
          </ProtectedRoute>
        }
      />
    </TitledRoutes>
  );
};

export default App;
